import { render, staticRenderFns } from "./FastFiles.vue?vue&type=template&id=6c3dcd08&"
import script from "./FastFiles.vue?vue&type=script&lang=js&"
export * from "./FastFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports